import { API_ENDPOINT } from "../constants"
import { HTTP } from "./http"

export const ConfigurationService ={
    getAllAccounts: (data: {
        user_id: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/getAll`, data)
    },
    getAllInfoAccount: (data: {
        account_id: string
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/getAllInfoAccount`, data)
    },
    
    createForm: (data: {
        account_id: string,
        name: string,
        webhook: string,
        categories: string,
        keys: any[]
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/addForm`, data)
    },
    editForm: (data: {
        form_id: number, 
        account_id: string,
        name: string,
        webhook: string,
        categories: string,
        keys: any[]
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/editForm`, data)
    },
    deleteForm: (data: {
        form_id: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/deleteForm`, data)
    },
    getFormById: (data: {
        form_id: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/getFormById`, data)
    },
    saveTickects: (data: {
        account_id: number,
        time_live_ticket: number,
        download_media: number,
        send_media: number,
        max_outbound: number,
        max_tickets: number,
        automatic_assignment: number,
        labels_tickets: string,
        default_category: string
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/updateSettings`, data)
    },
    saveTemplateText: (data: {
        account_id: number,
        text: string,
        sub_account: number 
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/addTemplates`, data)
    },
    editTemplateText: (data: {
        templete_id: number,
        account_id: number,
        text: string,
        sub_account: number 
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/editTemplates`, data)
    },
    changeStatusTemplateText: (data: {
        templete_id: number,
        status: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/changeTempleteStatus`, data)
    },
    deleteTemplateText: (data: {
        templete_id: number,
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/deleteTemplete`, data)
    },
    saveTemplateImage: (data: FormData) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/saveImage`, data)
    },
    saveTemplateFile: (data: FormData) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/saveFile`, data)
    },
    deleteTemplateFile: (data: {
        file_id: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/deleteFile`, data)
    },
    saveAlert: (data: {
        account_id: string
        v3_tiempo_pregunta: number,
        v3_tiempo_espera: number,
        v3_tickets_encolados: number,
        v3_tiempo_maximo_descanso: number,
        v3_limite_tt_agente: number,
        v3_limite_tt_oubound: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/updateAlerts`, data)
    },
    changeRestrictStatus: (data: {
        status_of_table_id: number,
        status: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/changeStatusOfRestriction`, data)
    },
    deleteStatusOfStatus: (data: {
        status_of_table_id: number,
        status: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/changeStatusOfTable`, data)
    },
    saveStatusOfStatus: (data: {
        status_table_id: number,
        name: string,
        sub_account: string,
        messages_restriccion: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/addStatusTable`, data)
    },
    updateSchedules: (data: {
        id: number,
        account_id: number,
        status: number,
        limited_connection: number,
        limited_asignation: number,
        automatic_messages: number,
        Monday_start: string,
        Monday_end: string,
        Tuesday_start: string,
        Tuesday_end: string,
        Wednesday_start: string,
        Wednesday_end: string,
        Thursday_start: string,
        Thursday_end: string,
        Friday_start: string,
        Friday_end: string,
        Saturday_start: string,
        Saturday_end: string,
        Sunday_start: string,
        Sunday_end: string,
        Monday_status: boolean,
        Tuesday_status: boolean,
        Wednesday_status: boolean,
        Thursday_status: boolean,
        Friday_status: boolean,
        Saturday_status: boolean,
        Sunday_status: boolean
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/updateBusinessHours`, data)
    },
    saveMessagesAutomatic: (data: {
        id: number,
        account_id: number,
        welcome_message: string,
        welcome_status: number,
        bye_message: string,
        bye_status: number,
        out_hours_message: string,
        out_hours_status: number,
        holiday_message: string,
        holiday_status: number,
        business_day_message: string,
        business_day_status: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/updateMessagesAutomatic`, data)
    },
    savePermissionsAgent: (data: {
        account_id: string,
        set_status: number,
        show_historical: number,
        redirect_ticket: number,
        block_ticket: number,
        show_contacts: number,
        add_contacts: number,
        open_ticket_contacts: number,
        show_tickets: number,
        reopen_ticket: number,
        show_calendar: number,
        add_event: number,
        schedule_message: number,
        show_emojis: number,
        show_attach: number
    }) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/v3.1/settings-agent`, data)
    },
}
